/**
 * Notify the user that a revised First Draft is ready for review.
 * Plays a short two-tone audio ping and sends a browser notification.
 */

function playAudioPing(): void {
  const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
  if (!AudioCtx) return;

  const ctx = new AudioCtx();
  const now = ctx.currentTime;

  // Two-tone "ding-ding" — C5 + E5 (pleasant major third)
  const tones: [number, number][] = [[523.25, 0], [659.25, 0.23]];
  const duration = 0.15;

  for (const [freq, offset] of tones) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "sine";
    osc.frequency.value = freq;

    gain.gain.setValueAtTime(0, now + offset);
    gain.gain.linearRampToValueAtTime(0.3, now + offset + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.001, now + offset + duration);

    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now + offset);
    osc.stop(now + offset + duration);
  }

  setTimeout(() => void ctx.close(), 1000);
}

function sendBrowserNotification(): void {
  if (!("Notification" in window)) return;

  if (Notification.permission === "granted") {
    new Notification("First Draft Ready for Review", {
      body: "A revised First Draft is ready. Return to the review page to continue.",
      icon: "/favicon.ico",
    });
    return;
  }

  if (Notification.permission !== "denied") {
    void Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        new Notification("First Draft Ready for Review", {
          body: "A revised First Draft is ready. Return to the review page to continue.",
          icon: "/favicon.ico",
        });
      }
    });
  }
}

export function notifyPlanReady(): void {
  try {
    playAudioPing();
  } catch {
    // Audio is nice-to-have
  }
  try {
    sendBrowserNotification();
  } catch {
    // Notification is nice-to-have
  }
}
